import { useRef } from 'react';
import { useTimeRange } from '../runtime';

export function useBeforeTimeRangeChange(callback: () => void) {
  const { refreshKey } = useTimeRange();
  // If the refresh key changes, handle things like query updates before queries get executed
  const lastRefreshKey = useRef(refreshKey);

  if (lastRefreshKey.current !== refreshKey) {
    callback();
  }

  lastRefreshKey.current = refreshKey;
}
